import React, { useState } from "react";
import "../components/css/newsletter.css"
import eye from "../assets/eye.gif"
import fmi from "../assets/Farmer-bro.png"

export default function NewsletterSubscription() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simple email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }
    
    
    setSubscribed(true);
    setEmail("");
  };

  return (
    <section className="newsletter-section">
      <div className="newsletter-container">
        <div className="newsletter-content">
          
          <h2>Stay Updated with Farming Tips</h2>
          <p>
            Subscribe to our newsletter for seasonal farming insights, latest
            agricultural technology updates, and exclusive app feature previews.
          </p>
          
          {!subscribed ? (
            <form onSubmit={handleSubmit} className="newsletter-form">
              <div className="input-groupt">
                <input
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="Enter your email address"
                  className={`newsletter-input ${error ? "input-error" : ""}`}
                />
                <button type="submit" className="newsletter-button">
                  Subscribe
                </button>
              </div>
              {error && <div className="error-message">{error}</div>}
              <div className="privacy-note">
                We respect your privacy. Unsubscribe at any time.
              </div>
            </form>
          ) : (
            <div className="success-message">
              <div className="success-icon">✓</div>
              <p>Thank you for subscribing!</p>
              <p>You'll receive our next newsletter in your inbox.</p>
            </div>
          )}
        </div>
        <div className="ilus-img">
        <img src={fmi} alt="" />

        </div>
        
       
      </div>
    </section>
  );
}